/**
 * WHO Child Growth Standards
 * Weight-for-age (kg), Length-for-age (cm), and Head Circumference-for-age (cm)
 * percentile reference values
 * Source: WHO Child Growth Standards (2006 / 2007)
 * Columns: [P3, P10, P50, P90, P97] at months 0–24
 */

type Row = [number, number, number, number, number]; // [P3, P10, P50, P90, P97]

const WEIGHT_BOYS: Row[] = [
  [2.5,  2.8,  3.3,  3.9,  4.3],  // 0
  [3.4,  3.7,  4.5,  5.2,  5.7],  // 1
  [4.4,  4.7,  5.6,  6.3,  7.0],  // 2
  [5.1,  5.5,  6.4,  7.2,  8.0],  // 3
  [5.6,  6.0,  7.0,  7.9,  8.7],  // 4
  [6.1,  6.5,  7.5,  8.5,  9.3],  // 5
  [6.4,  6.9,  7.9,  9.0,  9.7],  // 6
  [6.7,  7.2,  8.3,  9.4, 10.2],  // 7
  [7.0,  7.5,  8.6,  9.7, 10.5],  // 8
  [7.2,  7.7,  8.9, 10.0, 10.9],  // 9
  [7.5,  8.0,  9.2, 10.4, 11.2],  // 10
  [7.7,  8.2,  9.4, 10.6, 11.5],  // 11
  [7.8,  8.4,  9.6, 10.9, 11.8],  // 12
  [8.0,  8.6,  9.9, 11.1, 12.1],  // 13
  [8.2,  8.8, 10.1, 11.4, 12.3],  // 14
  [8.4,  9.0, 10.3, 11.7, 12.6],  // 15
  [8.5,  9.2, 10.5, 11.9, 12.9],  // 16
  [8.7,  9.4, 10.7, 12.1, 13.1],  // 17
  [8.9,  9.5, 10.9, 12.4, 13.4],  // 18
  [9.0,  9.7, 11.1, 12.6, 13.7],  // 19
  [9.2,  9.9, 11.3, 12.8, 13.9],  // 20
  [9.3, 10.1, 11.5, 13.0, 14.1],  // 21
  [9.5, 10.2, 11.7, 13.3, 14.4],  // 22
  [9.6, 10.4, 11.9, 13.5, 14.6],  // 23
  [9.8, 10.6, 12.1, 13.7, 14.9],  // 24
];

const WEIGHT_GIRLS: Row[] = [
  [2.4,  2.7,  3.2,  3.7,  4.2],  // 0
  [3.2,  3.4,  4.2,  4.9,  5.4],  // 1
  [3.9,  4.3,  5.1,  6.0,  6.6],  // 2
  [4.5,  4.9,  5.8,  6.8,  7.5],  // 3
  [5.0,  5.4,  6.4,  7.5,  8.2],  // 4
  [5.4,  5.8,  6.9,  8.1,  8.8],  // 5
  [5.7,  6.2,  7.3,  8.5,  9.3],  // 6
  [6.0,  6.5,  7.6,  8.9,  9.7],  // 7
  [6.3,  6.8,  7.9,  9.3, 10.1],  // 8
  [6.5,  7.0,  8.2,  9.6, 10.5],  // 9
  [6.7,  7.2,  8.5,  9.9, 10.8],  // 10
  [6.9,  7.4,  8.7, 10.2, 11.1],  // 11
  [7.1,  7.6,  8.9, 10.5, 11.4],  // 12
  [7.2,  7.8,  9.2, 10.8, 11.7],  // 13
  [7.4,  8.0,  9.4, 11.0, 12.0],  // 14
  [7.6,  8.2,  9.6, 11.3, 12.3],  // 15
  [7.7,  8.4,  9.8, 11.5, 12.6],  // 16
  [7.9,  8.5, 10.0, 11.8, 12.9],  // 17
  [8.1,  8.7, 10.2, 12.0, 13.2],  // 18
  [8.2,  8.9, 10.4, 12.3, 13.5],  // 19
  [8.4,  9.1, 10.6, 12.5, 13.7],  // 20
  [8.5,  9.2, 10.9, 12.8, 14.0],  // 21
  [8.7,  9.4, 11.1, 13.0, 14.3],  // 22
  [8.8,  9.6, 11.3, 13.2, 14.6],  // 23
  [9.0,  9.7, 11.5, 13.5, 14.8],  // 24
];

const HEIGHT_BOYS: Row[] = [
  [46.1, 47.5, 49.9, 52.3, 53.7],  // 0
  [50.8, 52.2, 54.7, 57.2, 58.6],  // 1
  [54.4, 55.8, 58.4, 61.0, 62.4],  // 2
  [57.3, 58.8, 61.4, 64.0, 65.5],  // 3
  [59.7, 61.3, 63.9, 66.5, 68.0],  // 4
  [61.7, 63.3, 65.9, 68.6, 70.1],  // 5
  [63.3, 65.0, 67.6, 70.3, 72.0],  // 6
  [64.8, 66.6, 69.2, 71.8, 73.5],  // 7
  [66.2, 68.0, 70.6, 73.2, 75.0],  // 8
  [67.5, 69.4, 72.0, 74.6, 76.5],  // 9
  [68.7, 70.6, 73.3, 76.0, 77.9],  // 10
  [69.9, 71.8, 74.5, 77.3, 79.2],  // 11
  [71.0, 73.0, 75.7, 78.5, 80.5],  // 12
  [72.1, 74.2, 76.9, 79.7, 81.8],  // 13
  [73.1, 75.2, 78.0, 80.9, 83.0],  // 14
  [74.1, 76.2, 79.1, 82.0, 84.2],  // 15
  [75.0, 77.2, 80.2, 83.0, 85.4],  // 16
  [76.0, 78.1, 81.2, 84.1, 86.5],  // 17
  [76.9, 79.1, 82.3, 85.2, 87.7],  // 18
  [77.7, 80.0, 83.2, 86.2, 88.8],  // 19
  [78.6, 80.9, 84.2, 87.2, 89.9],  // 20
  [79.4, 81.8, 85.1, 88.2, 90.9],  // 21
  [80.2, 82.6, 86.0, 89.1, 91.9],  // 22
  [81.0, 83.4, 86.9, 90.1, 92.9],  // 23
  [81.7, 84.3, 87.8, 91.0, 93.9],  // 24
];

const HEIGHT_GIRLS: Row[] = [
  [45.4, 46.8, 49.1, 51.5, 53.0],  // 0
  [49.8, 51.3, 53.7, 56.2, 57.8],  // 1
  [53.0, 54.5, 57.1, 59.7, 61.3],  // 2
  [55.6, 57.2, 59.8, 62.5, 64.1],  // 3
  [57.8, 59.5, 62.1, 64.7, 66.4],  // 4
  [59.6, 61.3, 64.0, 66.7, 68.4],  // 5
  [61.2, 63.0, 65.7, 68.5, 70.3],  // 6
  [62.7, 64.5, 67.3, 70.1, 71.9],  // 7
  [64.0, 65.9, 68.7, 71.7, 73.5],  // 8
  [65.3, 67.3, 70.1, 73.1, 75.0],  // 9
  [66.5, 68.5, 71.5, 74.4, 76.5],  // 10
  [67.7, 69.8, 72.8, 75.8, 77.9],  // 11
  [68.9, 71.0, 74.0, 77.1, 79.2],  // 12
  [70.0, 72.2, 75.2, 78.4, 80.5],  // 13
  [71.0, 73.4, 76.4, 79.6, 81.8],  // 14
  [72.0, 74.5, 77.5, 80.8, 83.1],  // 15
  [73.0, 75.5, 78.6, 82.0, 84.3],  // 16
  [74.0, 76.5, 79.7, 83.1, 85.5],  // 17
  [74.9, 77.5, 80.7, 84.1, 86.6],  // 18
  [75.8, 78.4, 81.7, 85.2, 87.7],  // 19
  [76.7, 79.4, 82.7, 86.2, 88.8],  // 20
  [77.5, 80.3, 83.7, 87.2, 89.9],  // 21
  [78.4, 81.2, 84.6, 88.2, 90.9],  // 22
  [79.2, 82.0, 85.5, 89.2, 91.9],  // 23
  [80.0, 82.9, 86.4, 90.1, 92.8],  // 24
];

/* ─── Head Circumference-for-age ───────────────────────────────────────────── */

const HC_BOYS: Row[] = [
  [32.1, 33.0, 34.5, 36.0, 36.9],  // 0
  [35.1, 36.1, 37.3, 38.5, 39.5],  // 1
  [37.0, 37.9, 39.1, 40.3, 41.2],  // 2
  [38.3, 39.3, 40.5, 41.8, 42.7],  // 3
  [39.4, 40.4, 41.6, 42.8, 43.8],  // 4
  [40.3, 41.3, 42.6, 43.8, 44.7],  // 5
  [41.0, 42.1, 43.3, 44.5, 45.5],  // 6
  [41.7, 42.8, 44.0, 45.2, 46.2],  // 7
  [42.3, 43.4, 44.6, 45.9, 46.8],  // 8
  [42.8, 44.0, 45.2, 46.4, 47.4],  // 9
  [43.3, 44.4, 45.6, 46.9, 47.9],  // 10
  [43.7, 44.9, 46.1, 47.4, 48.3],  // 11
  [44.1, 45.3, 46.5, 47.8, 48.7],  // 12
  [44.5, 45.6, 46.9, 48.2, 49.1],  // 13
  [44.8, 46.0, 47.2, 48.5, 49.5],  // 14
  [45.1, 46.3, 47.5, 48.8, 49.8],  // 15
  [45.4, 46.6, 47.8, 49.1, 50.1],  // 16
  [45.7, 46.9, 48.1, 49.4, 50.4],  // 17
  [45.9, 47.1, 48.4, 49.7, 50.7],  // 18
  [46.1, 47.4, 48.7, 50.0, 51.0],  // 19
  [46.4, 47.6, 48.9, 50.2, 51.2],  // 20
  [46.6, 47.8, 49.1, 50.5, 51.5],  // 21
  [46.8, 48.0, 49.4, 50.7, 51.7],  // 22
  [47.0, 48.2, 49.6, 50.9, 51.9],  // 23
  [47.1, 48.4, 49.8, 51.1, 52.1],  // 24
];

const HC_GIRLS: Row[] = [
  [31.7, 32.5, 33.9, 35.2, 36.1],  // 0
  [34.3, 35.3, 36.6, 37.9, 38.9],  // 1
  [36.1, 37.1, 38.4, 39.7, 40.7],  // 2
  [37.5, 38.5, 39.9, 41.2, 42.2],  // 3
  [38.6, 39.7, 41.0, 42.3, 43.2],  // 4
  [39.6, 40.7, 42.0, 43.3, 44.3],  // 5
  [40.4, 41.5, 42.9, 44.2, 45.2],  // 6
  [41.2, 42.3, 43.6, 44.9, 46.0],  // 7
  [41.8, 43.0, 44.4, 45.7, 46.7],  // 8
  [42.4, 43.6, 45.0, 46.3, 47.3],  // 9
  [43.0, 44.2, 45.5, 46.9, 47.9],  // 10
  [43.5, 44.7, 46.1, 47.4, 48.5],  // 11
  [44.0, 45.2, 46.5, 47.9, 48.9],  // 12
  [44.4, 45.7, 47.0, 48.4, 49.4],  // 13
  [44.8, 46.1, 47.4, 48.8, 49.8],  // 14
  [45.2, 46.5, 47.8, 49.2, 50.3],  // 15
  [45.5, 46.8, 48.2, 49.6, 50.6],  // 16
  [45.8, 47.2, 48.5, 49.9, 51.0],  // 17
  [46.1, 47.4, 48.8, 50.3, 51.3],  // 18
  [46.4, 47.7, 49.1, 50.6, 51.7],  // 19
  [46.6, 48.0, 49.4, 50.9, 51.9],  // 20
  [46.9, 48.2, 49.7, 51.2, 52.2],  // 21
  [47.1, 48.5, 50.0, 51.5, 52.5],  // 22
  [47.3, 48.7, 50.2, 51.7, 52.8],  // 23
  [47.5, 48.9, 50.4, 51.9, 53.0],  // 24
];

export interface WHORef {
  month: number;
  p3: number;
  p10: number;
  p50: number;
  p90: number;
  p97: number;
}

function tableToRef(rows: Row[]): WHORef[] {
  return rows.map((r, i) => ({ month: i, p3: r[0], p10: r[1], p50: r[2], p90: r[3], p97: r[4] }));
}

export const WHO_WEIGHT_BOYS   = tableToRef(WEIGHT_BOYS);
export const WHO_WEIGHT_GIRLS  = tableToRef(WEIGHT_GIRLS);
export const WHO_HEIGHT_BOYS   = tableToRef(HEIGHT_BOYS);
export const WHO_HEIGHT_GIRLS  = tableToRef(HEIGHT_GIRLS);
export const WHO_HC_BOYS       = tableToRef(HC_BOYS);
export const WHO_HC_GIRLS      = tableToRef(HC_GIRLS);

export function getWHOTable(metric: 'weight' | 'height' | 'hc', gender: 'boy' | 'girl'): WHORef[] {
  if (metric === 'weight') return gender === 'boy' ? WHO_WEIGHT_BOYS : WHO_WEIGHT_GIRLS;
  if (metric === 'hc')     return gender === 'boy' ? WHO_HC_BOYS     : WHO_HC_GIRLS;
  return gender === 'boy' ? WHO_HEIGHT_BOYS : WHO_HEIGHT_GIRLS;
}

/** Interpolate a WHO reference row at a fractional month */
function interpolateRef(table: WHORef[], monthF: number): WHORef {
  const clamped = Math.max(0, Math.min(24, monthF));
  const lo = Math.min(23, Math.floor(clamped));
  const hi = lo + 1;
  const t  = clamped - lo;
  const a  = table[lo];
  const b  = table[hi];
  return {
    month: clamped,
    p3:  a.p3  + (b.p3  - a.p3)  * t,
    p10: a.p10 + (b.p10 - a.p10) * t,
    p50: a.p50 + (b.p50 - a.p50) * t,
    p90: a.p90 + (b.p90 - a.p90) * t,
    p97: a.p97 + (b.p97 - a.p97) * t,
  };
}

/**
 * Estimate the percentile of a measurement value at a given age.
 * Returns 0–100 (clamped).
 */
export function getPercentile(
  value: number,
  ageMonths: number,
  metric: 'weight' | 'height' | 'hc',
  gender: 'boy' | 'girl'
): number {
  const table = getWHOTable(metric, gender);
  const ref   = interpolateRef(table, ageMonths);

  const bands: [number, number][] = [
    [0,   ref.p3],
    [3,   ref.p3],
    [10,  ref.p10],
    [50,  ref.p50],
    [90,  ref.p90],
    [97,  ref.p97],
    [100, ref.p97],
  ];

  if (value <= ref.p3)  return 3;
  if (value >= ref.p97) return 97;

  for (let i = 1; i < bands.length - 1; i++) {
    const [pLo, vLo] = bands[i];
    const [pHi, vHi] = bands[i + 1];
    if (value >= vLo && value <= vHi) {
      const t = (value - vLo) / (vHi - vLo);
      return Math.round(pLo + t * (pHi - pLo));
    }
  }
  return 50;
}

/** Age in fractional months from DOB to a given date */
export function ageInMonths(dob: Date, at: Date): number {
  return (at.getTime() - dob.getTime()) / (1000 * 60 * 60 * 24 * 30.4375);
}
